import { render, staticRenderFns } from "./AdminProdCat.vue?vue&type=template&id=0da82448&scoped=true&"
import script from "./AdminProdCat.vue?vue&type=script&lang=js&"
export * from "./AdminProdCat.vue?vue&type=script&lang=js&"
import style0 from "./AdminProdCat.vue?vue&type=style&index=0&id=0da82448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da82448",
  null
  
)

export default component.exports